import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { NavHashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

import Container from './styled-components/Container';
import Wrapper from './styled-components/Wrapper';
import logo from '../assets/img/header-logo.svg';
import Image from './styled-components/Image';
import Button from './styled-components/Button';
import ToggleButton from './MenuToggleButton';
import useOnClickOutside from '../helpers/useOnClickOutside';
import scrollWithOffset from '../helpers/scrollWithOffset';
import { screen } from '../variables';
import avatar from '../assets/img/avatar.svg';

export default function Header(props) {
  const { loggedIn } = props;
  const [open, setOpen] = useState(false);

  const headerNavigation = [
    {
      title: 'Mein Wochenplan',
      href: '/mein-wochenplan',
    },
    {
      title: "So funktioniert's",
      href: '/#so-funktionierts',
    },
    {
      title: 'Newsletter',
      href: '/#newsletter',
    },
    {
      title: 'Team',
      href: '/#team',
    },
    {
      title: 'Kontakt',
      href: '/#kontakt',
    },
  ];

  const nav = useRef();
  useOnClickOutside(nav, () => setOpen(false));

  console.log(loggedIn ? 'User ist eingeloggt.' : 'User ist ausgeloggt.');

  return (
    <StyledHeader ref={nav}>
      <Container noPaddingOnMobile>
        <Wrapper flex nav>
          <Link to="/" onClick={() => window.scrollTo(0, 0)}>
            <Logo>
              <Image src={logo} alt="Logo" />
            </Logo>
          </Link>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Navigation flex open={open} loggedIn={loggedIn}>
              <div className="logo">
                <Image src={logo} alt="Logo" />
              </div>
              <div>
                {loggedIn && (
                  <Link to="/einstellungen">
                    <Image
                      src={avatar}
                      alt="Avatar"
                      mobileMargin="0 19px 0 0"
                      className="only-mobile"
                    />
                  </Link>
                )}
                <Button
                  label={loggedIn ? 'Abmelden' : 'Anmelden'}
                  small
                  reverse={loggedIn ? true : false}
                  href="/login"
                  loggedIn={loggedIn}
                  onClick={() => setOpen(false)}
                />
              </div>
              <ul>
                {headerNavigation.map((link) => (
                  <li key={link.href}>
                    <NavHashLink
                      smooth
                      to={link.href}
                      onClick={() => setOpen(false)}
                      activeClassName="selected"
                      scroll={scrollWithOffset}
                      // activeStyle={{ color: '#13A583' }}
                    >
                      {link.title}
                    </NavHashLink>
                  </li>
                ))}
              </ul>
            </Navigation>
            <div className="sign-up">
              {loggedIn && (
                <Link to="/einstellungen">
                  <Image src={avatar} alt="Avatar" className="only-desktop" />
                </Link>
              )}
              <Button
                label={loggedIn ? 'Abmelden' : 'Anmelden'}
                reverse={loggedIn ? true : false}
                small
                href="/login"
                loggedIn={loggedIn}
              />
            </div>
          </div>
          <Toggle>
            {loggedIn && (
              <Link to="/einstellungen">
                <Image src={avatar} alt="Avatar" className="only-mobile" />
              </Link>
            )}
            <ToggleButton open={open} setOpen={setOpen} />
          </Toggle>
        </Wrapper>
      </Container>
    </StyledHeader>
  );
}

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14),
    0px 1px 10px rgba(0, 0, 0, 0.12);

  .sign-up {
    display: flex;
    align-items: center;

    @media (max-width: ${screen.tablet}px) {
      display: none;
    }

    a {
      display: flex;
      align-items: center;

      img {
        margin-right: 19px;
      }
    }
  }
`;

const Navigation = styled.nav`
  margin-right: 46px;

  @media (max-width: ${screen.tablet}px) {
    display: ${(props) => (props.open ? 'block' : 'none')};
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    width: 251px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14),
      0px 1px 10px rgba(0, 0, 0, 0.12);
    margin-right: 0;
    overflow-y: auto;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    ${(props) =>
      props.flex &&
      `display: flex;
       flex-flow: row wrap;
      `};

    li {
      margin-right: ${(props) => (props.flex ? '24px' : '0')};

      &:last-child {
        margin-right: 0;
      }

      &:hover a {
        color: #13a583;
      }

      a {
        color: #3d403f;
        font-size: 18px;
        text-decoration: none;
      }
    }

    @media (max-width: ${screen.tablet}px) {
      box-sizing: border-box;
      margin: 0;
      list-style-type: none;
      display: flex;
      flex-direction: column;

      li {
        margin: 0;
        padding: 20px 0;

        &:hover a {
          color: #3d403f;
        }

        a {
          color: #3d403f;
          font-size: 18px;
          text-decoration: none;
          padding: 20px 24px;
          font-weight: 600;
        }
      }
    }
  }

  .logo {
    display: none;

    @media (max-width: ${screen.tablet}px) {
      display: block;
      padding: 23px 24px 16px 24px;
      border-bottom: 1px solid #969696;
    }

    img {
      @media (max-width: ${screen.tablet}px) {
        width: 132px;
      }
    }
  }

  div:nth-child(2) {
    @media (min-width: ${screen.tablet}px) {
      display: none;
    }

    display: flex;
    margin: 24px 24px 24px 20px;

    a:nth-child(1) {
      ${(props) =>
        !props.loggedIn
          ? 'flex: 0 0 100%'
          : 'margin-right: 19px; display: flex; align-items: center'};
    }
    a:nth-child(2) {
      ${(props) => props.loggedIn && 'width: 100%'};
    }

    button {
      @media (max-width: ${screen.tablet}px) {
        display: block;
        width: 100%;
      }
    }
  }
`;

const Logo = styled.div`
  margin: 16px 0 8px 0;
  flex: 0 0 154px;
  cursor: pointer;

  @media (max-width: ${screen.tablet}px) {
    margin: 12px 0 0 18px;

    img {
      height: 36px;
    }
  }
`;

const Toggle = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: ${screen.tablet + 1}px) {
    display: none;
  }

  img {
    margin-bottom: -7px;
  }
`;
